import { required, maxLength, requiredIf } from 'vuelidate/lib/validators'
import CountrySettingService from './CountrySettingService'

const gstRateGreaterThanZero = function (value) {
  if (!this.entity.isGST) {
    return true
  }
  return value > 0
}

const withHoldTaxGreaterThanZero = function (value) {
  if (!this.entity.isWithHold) {
    return true
  }
  return value > 0
}

const countryCodeUnique = async function (value) {
  if (!value) {
    return true
  }
  try {
    const countryId = this.entity.countryId || 0
    const exists = await CountrySettingService.checkcountrycodevalidity(countryId, value)
    return !exists
  } catch (e) {
    console.error('Error checking country code validity:', e)
    return true
  }
}

export default {
  provide: function () {
    return {
      $vv: this.$v
    }
  },
  validations: {
    detailGroup: ['entity.countryCode', 'entity.countryDesc', 'entity.nationality', 'entity.callingCode', 'entity.gstRate', 'entity.withHoldTax'],
    entity: {
      countryCode: {
        required,
        maxLength: maxLength(2),
        countryCodeUnique
      },
      countryDesc: {
        required
      },
      nationality: {
        required
      },
      callingCode: {
        required
      },
      gstRate: {
        required: requiredIf(function () {
          return this.entity.isGST
        }),
        gstRateGreaterThanZero
      },
      withHoldTax: {
        required: requiredIf(function () {
          return this.entity.isWithHold
        }),
        withHoldTaxGreaterThanZero
      }
    },
    filter: {}
  }
}
